import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d3dhhirbr3iihosg1b9g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData,
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-gray-900 relative overflow-hidden">
      {/* Gold glow accents */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-yellow-400/5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent"></div>
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-500/20 to-transparent"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/25 mb-6">
          <i className="ri-mail-line text-amber-400 mr-2 text-sm"></i>
          <span className="text-xs font-semibold text-amber-400 tracking-widest uppercase">Newsletter</span>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Stay{' '}
          <span className="bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">
            Updated
          </span>
        </h2>
        <p className="text-lg text-gray-400 mb-10">
          Get the latest news and updates from Villarreal Enterprise Group and our subsidiary companies.
        </p>

        <form onSubmit={handleSubmit} className="max-w-lg mx-auto" data-readdy-form id="newsletter-form">
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="flex-1 px-5 py-3 rounded-lg bg-gray-950 border border-gray-700 focus:border-amber-500/60 focus:ring-1 focus:ring-amber-500/30 text-white placeholder-gray-500 text-sm outline-none transition-all duration-300"
            />
            <Button type="submit" variant="primary" size="md" disabled={isSubmitting}>
              {isSubmitting ? (
                <i className="ri-loader-4-line animate-spin"></i>
              ) : (
                <>
                  <i className="ri-send-plane-line mr-2"></i>
                  Subscribe
                </>
              )}
            </Button>
          </div>

          {submitStatus === 'success' && (
            <div className="mt-4 flex items-center justify-center gap-2 text-amber-400 text-sm">
              <i className="ri-checkbox-circle-line"></i>
              Thank you for subscribing!
            </div>
          )}
          {submitStatus === 'error' && (
            <div className="mt-4 flex items-center justify-center gap-2 text-red-400 text-sm">
              <i className="ri-error-warning-line"></i>
              Sorry, there was an error. Please try again.
            </div>
          )}
        </form>

        <p className="text-xs text-gray-600 mt-5">
          We respect your privacy. Unsubscribe at any time.
        </p>
      </div>
    </section>
  );
}
